import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SearchableDropdown = ({
  globalIndex,
  field,
  value,
  onChange,
  onSearch,
  dropdownData,
  placeholder = "",
  focusedCell,
  setFocusedCell,
  showDropdown,
  setShowDropdown,
  dropdownRef,
  setOffset,
  offset,
  search_input,
  hasMore,
  getData,
  createNewUrl, // optional create new URL
  createNewLabel = "+ Create New", // optional label for create button
}) => {
  const navigate = useNavigate();

  // ✅ Infinite scroll logic
  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown) return;

    const handleScroll = () => {
      if (
        dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 &&
        hasMore
      ) {
        const newOffset = offset + 20;
        setOffset(newOffset);
        getData(newOffset, search_input);
      }
    };

    dropdown.addEventListener("scroll", handleScroll);
    return () => dropdown.removeEventListener("scroll", handleScroll);
  }, [offset, hasMore, search_input]);

  // ✅ Add “+ Create New” option to dropdown
  const finalDropdownData = createNewUrl
    ? [{ isNew: true, name: createNewLabel }, ...(dropdownData || [])]
    : dropdownData || [];

  return (
    <td
      className="p-0 d-flex justify-content-center"
      style={{
        position: "relative",
        border:
          focusedCell.rowIndex === globalIndex && focusedCell.field === field
            ? "0.3px solid #270b79"
            : "",
      }}
    >
      {/* Input box */}
      <input
        type="text"
        id={`${placeholder}`}
        className="form-control tableinput noborder"
        style={{ fontSize: "0.8rem", textAlign: "center" }}
        placeholder={placeholder}
        value={value}
        onFocus={() => {
          setTimeout(() => {
            setShowDropdown({ rowIndex: globalIndex, field });
            setFocusedCell({ rowIndex: globalIndex, field });
          }, 150);
        }}
        onBlur={() => {
          // Delay hiding dropdown so click can finish
          setTimeout(() => {
            setShowDropdown({ rowIndex: null, field: null });
            setFocusedCell({ rowIndex: null, field: null });
          }, 200);
        }}
        onChange={(e) => {
          const text = e.target.value;
          setOffset?.(0);
          onSearch(text);
          onChange(text);
        }}
      />

      {/* Dropdown list */}
      <div
        ref={dropdownRef}
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          maxHeight:
            showDropdown?.rowIndex === globalIndex &&
            showDropdown?.field === field
              ? "200px"
              : "0",
          display:
            showDropdown?.rowIndex === globalIndex &&
            showDropdown?.field === field
              ? "block"
              : "none",
          overflowY: "auto",
          background: "white",
          border:
            showDropdown?.rowIndex === globalIndex &&
            showDropdown?.field === field
              ? "1px solid #ccc"
              : "",
          zIndex: 10,
          // borderRadius: "8px",
          boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
          transition: "all 0.2s ease-in-out",
        }}
      >
        {finalDropdownData.length > 0 ? (
          finalDropdownData.map((item, idx) => (
            <div
              key={idx}
              onMouseDown={() => {
                if (item.isNew && createNewUrl) {
                  navigate(createNewUrl);
                } else {
                  const selectedValue =
                    item.name || item.label || item.value || "";
                  onChange(selectedValue);
                }
                setShowDropdown({ rowIndex: null, field: null });
              }}
              className={`dropdown-option ${
                item.isNew ? "create-new-option" : ""
              }`}
              style={{
                padding: "8px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
                backgroundColor: item.isNew ? "#6F3355" : "",
                color: item.isNew ? "white" : "",
                fontWeight: item.isNew ? "bold" : "normal",
                transition: "background 0.2s",
              }}
            >
              {item.name || item.label || item.value}
            </div>
          ))
        ) : (
          <div style={{ padding: "8px", color: "#888" }}>No results</div>
        )}
      </div>

      {/* ✅ Optional inline hover style */}
      <style>{`
        .dropdown-option:hover {
          background-color: #F5ECF0;
        }
        .create-new-option:hover {
          background-color: #5b2d4c;
        }
      `}</style>
    </td>
  );
};

export default SearchableDropdown;
